import DetailHeader from "./DetailHeader";

export default DetailHeader;
